import { Button } from '@mui/material';
import { BsEye, BsX } from 'react-icons/bs';
import { PiPaperPlaneTilt } from 'react-icons/pi';

import { Flex } from 'src/components/Flex';
import { SalesInvoiceAllocatePaymentCallToAction } from 'src/features/finance/salesInvoice/view/components/ViewSalesInvoiceCallToActions/components';

interface ViewSelfBillingInvoiceCallToActionsProps {
    readonly onAllocatePayment: () => void;
    readonly totalOutstanding: number;
    readonly allocating: boolean;
    readonly setShowPaymentAllocationModel: (value: boolean) => void;
    readonly showPaymentAllocationModal: boolean;
    readonly isSelfBillingInvoiceCreateFailed: boolean;
    readonly isSelfBillingInvoiceProcessing: boolean;
    readonly isSelfBillingInvoiceReleaseFailed: boolean;
    readonly isAllowedToAllocatePaymentToSelfBillingInvoice: boolean;
    readonly handleReleaseSelfBillingInvoice: () => void;
    readonly handleResubmitToSage: () => void;
    handleViewPDFModal: () => void;
    handleOpenSendModal: () => void;
}

export default function ViewSelfBillingInvoiceCallToActions({
    allocating,
    onAllocatePayment,
    setShowPaymentAllocationModel,
    showPaymentAllocationModal,
    totalOutstanding,
    isSelfBillingInvoiceCreateFailed,
    isSelfBillingInvoiceReleaseFailed,
    isSelfBillingInvoiceProcessing,
    isAllowedToAllocatePaymentToSelfBillingInvoice,
    handleReleaseSelfBillingInvoice,
    handleResubmitToSage,
    handleViewPDFModal,
    handleOpenSendModal,
}: ViewSelfBillingInvoiceCallToActionsProps) {
    if (isSelfBillingInvoiceProcessing) return null;

    return (
        <Flex
            alignItems="center"
            gap="8px"
            data-testid="view-self-billing-invoice-call-to-actions-container"
        >
            {isSelfBillingInvoiceCreateFailed && (
                <Button variant="npi-primary" onClick={handleResubmitToSage}>
                    Resubmit to Sage
                </Button>
            )}
            {isSelfBillingInvoiceReleaseFailed ? (
                <Button variant="npi-primary" onClick={handleReleaseSelfBillingInvoice}>
                    Release Invoice
                </Button>
            ) : (
                <>
                    {isAllowedToAllocatePaymentToSelfBillingInvoice && (
                        <SalesInvoiceAllocatePaymentCallToAction
                            allocating={allocating}
                            onAllocatePayment={onAllocatePayment}
                            setShowPaymentAllocationModel={setShowPaymentAllocationModel}
                            showPaymentAllocationModal={showPaymentAllocationModal}
                            totalOutstanding={totalOutstanding}
                        />
                    )}
                    <Button
                        key="0-handleView"
                        variant="npi-primary"
                        startIcon={<BsX />}
                        sx={{
                            minWidth: '40px !important',
                            width: '40px',
                            height: '40px',
                            padding: '0px',
                            '& span': {
                                marginRight: '0px',
                                marginLeft: '0px',
                            },
                            boxShadow: 'none',
                        }}
                    />
                    <Button
                        key="cancel-invoice"
                        variant="npi-primary"
                        startIcon={<BsEye />}
                        onClick={handleViewPDFModal}
                        sx={{
                            minWidth: '40px !important',
                            width: '40px',
                            height: '40px',
                            padding: '0px',
                            '& span': {
                                marginRight: '0px',
                                marginLeft: '0px',
                            },
                            boxShadow: 'none',
                        }}
                    />
                    <Button
                        key="1-handleSend"
                        variant="npi-primary"
                        startIcon={<PiPaperPlaneTilt />}
                        onClick={handleOpenSendModal}
                        sx={{
                            minWidth: '40px !important',
                            width: '40px',
                            height: '40px',
                            padding: '0px',
                            '& span': {
                                marginRight: '0px',
                                marginLeft: '0px',
                            },
                            boxShadow: 'none',
                        }}
                    />
                </>
            )}
        </Flex>
    );
}
